import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgControlNumberMinus({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 28 28"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle stroke="#4557A1" cx={14} cy={14} r={13.5} />
        <path
          d="M18.5 12.88h-9a.75.75 0 00-.75.74v.76c0 .4.34.74.75.74h9c.41 0 .75-.33.75-.74v-.76a.75.75 0 00-.75-.74z"
          fill="#4557A1"
        />
      </g>
    </svg>
  );
}

SvgControlNumberMinus.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgControlNumberMinus.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgControlNumberMinus svgRef={ref} {...props} />
));
export default ForwardRef;
